import { Box, Text } from '@factorialco/deprecated-design-system'
import { UpsellLandingPage } from 'generated/resources/graphql'

const SectionsHeader = ({ content }: { content: UpsellLandingPage | undefined }) => {
  return (
    <Box className="mx-auto" alignItems="center" textAlign="center" gap="s8">
      <Text size="700" color="black" weight="bold">
        {content?.sectionsTitle}
      </Text>
      <Text size="400" color="black">
        {content?.sectionsDescription}
      </Text>
    </Box>
  )
}

export default SectionsHeader
